import { type T, Translate } from '../../i18n';
import { m } from '../../mithril';
import type { MithrilVNode } from '../../mithril';
import { addStyles, DefaultTheme } from '../theme';

const CSS = {
	unit: 'c-unit',
};

const Style = {
	[CSS.unit]: {
		'font-weight': DefaultTheme.font.weight.bold,
		'margin-left': DefaultTheme.space(1),
		'margin-right': DefaultTheme.space(2),
	},
};

addStyles(Style);

export const Unit = {
	view(name: T): MithrilVNode {
		return m('sup', { className: CSS.unit }, Translate(name));
	},
};
